import { useEffect, useState } from "react";

function useCheckHighlight() {
	const [textHighlight, setTextHighlight] = useState(false);

	useEffect(() => {
		const checkTextHighlight = () => {
			const selection = window.getSelection();
			if (selection?.toString() !== "") {
				setTextHighlight(true);
			} else {
				setTextHighlight(false);
			}
		};
		document.addEventListener("mouseup", checkTextHighlight);
		document.addEventListener("mousedown", checkTextHighlight);
		return () => {
			document.removeEventListener("mouseup", checkTextHighlight);
			document.removeEventListener("mousedown", checkTextHighlight);
		};
	}, []);

	return textHighlight;
}

export default useCheckHighlight;
